<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All External Users</h5>
                <p class="mb-0 text-sm">
                  Below the list of registered external users.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link
                    :to="{ 
                      path: '/external-users/new',
                      query: $route.query  
                    }"
                    class="mb-0 btn bg-gradient-success btn-sm me-2"
                    target="_blank"
                    >+&nbsp; Add New</router-link>
                  <button
                    type="button"
                    class="mx-1 mb-0 btn btn-outline-success btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#import"
                    v-if="false"
                  >
                    Import
                  </button>
                  <div
                    id="import"
                    class="modal fade"
                    tabindex="-1"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog mt-lg-10">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 id="ModalLabel" class="modal-title">
                            Import CSV
                          </h5>
                          <i class="fas fa-upload ms-3"></i>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          <p>You can browse your computer for a file.</p>
                          <input
                            type="text"
                            placeholder="Browse file..."
                            class="mb-3 form-control"
                          />
                          <div class="form-check">
                            <input
                              id="importCheck"
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              checked=""
                            />
                            <label
                              class="custom-control-label"
                              for="importCheck"
                              >I accept the terms and conditions</label
                            >
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn bg-gradient-secondary btn-sm"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            class="btn bg-gradient-success btn-sm"
                          >
                            Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                  <button
                    class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                    :class="{'disabled': exportLoading}"
                    @click="onClickExport()"
                  >
                    Export <i v-if="exportLoading" class="fas fa-spinner fa-pulse"></i>
                  </button>
                  
                  <download-excel
                    ref="btnExport"
                    class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0 d-none"
                    :data="recordsForExport"
                    :fields="json_fields"
                    :formats="formats"
                    :widths="excel_widths"
                    worksheet="My Worksheet"
                    name="external-users.xlsx"
                    type="xlsx"
                  >
                    Export
                  </download-excel>
                </div>
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <div class="row">
                        <div class="col-4">
                          <div class="input-daterange datepicker row align-items-center" >
                            <base-input addon-left-icon="ni ni-calendar-grid-58" >
                            <date-range-picker
                                ref="picker"
                                :opens="opts.opens"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                :singleDatePicker="opts.singleDatePicker"
                                :showWeekNumbers="opts.showWeekNumbers"
                                :showDropdowns="opts.showDropdowns"
                                :autoApply="opts.autoApply"
                                :dateRange="opts.dateRange"
                                :ranges="opts.ranges"
                                v-model="dates.range"
                                :linkedCalendars="opts.linkedCalendars"
                              >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ dateTime(picker.startDate) }} - {{ dateTime(picker.endDate) }}
                                </template>
                              </date-range-picker>
                            </base-input>
                          </div>
                      
                        </div>
                        <div class="col-2">
                          <select class="dataTable-selector form-select form-select-sm" v-model="kyc_status">
                            <option value="">KYC Status</option>
                            <option v-for="item in kycOpts" :value="item.value" :key="item.label" >{{ item.label }}</option>                        
                          </select>  
                        </div>
                        <div class="col-2">
                          <select class="dataTable-selector form-select form-select-sm" v-model="filter_by">
                            <option value="" disabled hidden>Search By</option>
                            <option v-for="item in filterOpts" :value="item.value" :key="item.label" >{{ item.label }}</option>                        
                          </select>          
                        </div>
                        <div class="col-3">
                          <input class="dataTable-input form-control" placeholder="Search..." type="text" v-model="search">
                        </div>
                        <div class="col">                                          
                          <button class="rounded btn btn-xs text-white bg-success" @click="getAllAPI()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            User Code
                          </th>
                          <th>
                            Fullname
                          </th>
                          <th>
                            Email
                          </th>
                          <th>
                            Phone
                          </th>
                          <th>
                            City
                          </th>
                          <th>
                            Link Referral
                          </th>
                          <th>
                            Referred By
                          </th>
                          <th>
                            Joined At
                          </th>
                          <th>
                            KYC Status
                          </th>
                          <th>
                            Status
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.id }}</td>
                          <td class="text-sm">{{ record.fullname }}</td>
                          <td class="text-sm">{{ record.username }}</td>
                          <td class="text-sm">{{ record.phone }}</td>
                          <td class="text-sm">{{ record.city }}</td>
                          <td class="text-sm">
                            <a href="javascript:;" data-bs-toggle="tooltip" data-bs-original-title="View Referral Link"
                            @click="copyReferralLink(record)"
                            >
                              Copy Referral Link
                            </a>
                          </td>
                          <td class="text-sm">{{ record.referred_by_name || 'n/a'}}</td>
                          <td class="text-sm">{{ dateTime(record.created_at) }}</td>
                          <td>
                            <router-link  
                              :to="{ 
                                path: '/external-users/kyc/'+ record.id,
                                query: $route.query  // <- meneruskan query dari route sekarang
                              }">
                              <span class="badge badge-danger badge-sm" v-if="record.kyc_status == 'rejected'">Rejected</span>
                              <span class="badge badge-success badge-sm" v-else-if="record.kyc_status == 'approved'">Approved</span>
                              <span class="badge badge-info badge-sm" v-else-if="record.kyc_status == 'awaiting'">Need Approval</span>
                              <span class="badge badge-light badge-sm" v-else>Pending</span>
                            </router-link>
                            
                          </td>
                          <td>
                            <span class="badge badge-danger badge-sm" v-if="!record.is_active">Not Active</span>
                            <span class="badge badge-success badge-sm" v-else>Active</span>
                          </td>
                          <td class="text-sm">
                            <a :href="'/external-users/'+ record.id + '/referred'" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Referred" target="_blank">
                              <i class="fas fa-share-square text-secondary" aria-hidden="true"></i>
                            </a>
                            <router-link
                              :to="{ 
                                path: '/external-users/'+ record.id,
                                query: $route.query  // <- meneruskan query dari route sekarang
                              }" 
                              class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Edit user">
                              <i class="fas fa-user-edit text-secondary" aria-hidden="true"></i>
                            </router-link>
                            <a :href="'/external-users/'+ record.id + '/recap'" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Recap">
                              <i class="fas fa-file-pdf text-secondary" aria-hidden="true"></i>
                            </a>
                            <a href="javascript:;" @click="confirmationDelete(record.id)" data-bs-toggle="tooltip" data-bs-original-title="Delete user"
                            v-if="false"
                            >
                              <i class="fas fa-trash text-secondary" aria-hidden="true"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import UsersService from "@/services/users.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';
  import JsonExcel from "vue-json-excel3";
  import DateRangePicker from 'vue3-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import BaseInput from "@/components/BaseInput.vue";
  import useClipboard from 'vue-clipboard3'
  const toastId = ref('');

  const moment = require('moment');
  const { toClipboard } = useClipboard()
  

  export default {
    name: "ExternalUserList",
    data() {
      var startDate = new Date();
      var endDate = new Date();
      var thisMonthStart = moment().startOf('month').toDate();
      var thisMonthEnd = moment().endOf('month').toDate();
      const queryParam = this.$route.query
      
      if(queryParam.date_start != undefined && queryParam.date_start != "") {
        startDate = moment(queryParam.date_start, "YYYY-MM-DD").toDate()        
      }else{
        startDate.setDate(startDate.getDate() - 7)
      }

      if(queryParam.date_end != undefined && queryParam.date_end != "") {
        endDate = moment(queryParam.date_end, "YYYY-MM-DD").toDate()        
      }

      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0);
      const ranges = {
          'Today': [today, today],
          'Yesterday': [yesterday, yesterday],
          'This month': [thisMonthStart, thisMonthEnd],
          'This year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
          'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
          'Last year': [new Date(today.getFullYear() - 1, 0, 1), new Date(today.getFullYear() - 1, 11, 31)],
      }


      return {
        filterOpts: [{label: 'Username', value: 'username'} ,{label: 'Fullname', value: 'fullname'} , {label: 'City', value: 'city'}, {label: 'Customer Code', value: 'id'}],
        kycOpts: [{label: 'Pending', value: 'pending'} ,{label: 'Rejected', value: 'rejected'} , {label: 'Approved', value: 'approved'}],

        opts: {
          dateRange: {startDate,endDate},
          ranges: ranges,
          opens: "left",
          minDate: new Date(),
          maxDate: new Date(),
          singleDatePicker: false,
          showWeekNumbers: true,
          autoApply: false,
          linkedCalendars: true,
        },
        dates: {
          range: {startDate: startDate, endDate: endDate}
        },
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        sortBy: {
          name: 'created_at',
          sortType: '-1'
        },
        search: '',
        filter_by: '',
        kyc_status: '',
        formats: {
          'D': '@',
          'I': '@',
          'K': '@',
          'O': '@'
        },
        excel_widths: {
                D: 20,
                E: 40,
                F: 20,
                I: 25,
                K: 25,
                O: 25,
        },
        json_fields: {
            "ID": "id",
            "Fullname": "fullname",
            "Email": "username",
            "Phone": "phone",
            "Place Of Birth": "place_of_birth",
            "Birth Date": "birth_date",
            "Gender": "gender",
            "Identity Type": "id_card_type",
            "Identity ID": "id_card_number",
            "Tax Type": "npwp_type",
            "Tax Number": "npwp",
            "Trading Type": "trading_type",
            "Bank Name": "bank_name",
            "Bank Account Name": "bank_account_name",
            "Bank Account Number": "bank_account_number",
            "Residential Address": "residential_address",
            "Province": "province",
            "City": "city",
            "Country": "country",
            "Current Address": "current_address",
            "Employee Type": "employee_type",
            "Annual Income": "annual_income",
            "KYC Status": "kyc_status",
            "KYC Rejection Reason": "kyc_rejection_reason",

            "Is Active": "is_active",            
            "Joined At": "created_at",            
        },
        recordsForExport: [],
        exportLoading: false 
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      onClickExport(){
        this.exportLoading = true
        this.showLoading()

        const params = {
          limit: 1000,
          page: 1,
          filter: this.search,
          filter_by: this.filter_by,
          kyc_status: this.kyc_status,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        UsersService.getAll(params).then(e => {
          this.hideLoading()
          this.exportLoading = false
          const data = e.data
          this.recordsForExport = data.listofregistrationdata
          if(this.recordsForExport != null && this.recordsForExport.length > 0 ){
            this.$refs.btnExport.$el.click()
          }
        })
      },
      openReferralLink(record){
        record.show_link_referral = true
      },
      async copyReferralLink(record){
        try {
          await toClipboard(record.link_referral)
          console.log('Copied to clipboard')
        } catch (e) {
          console.error(e)
        }
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });        
      },
      deleteRecord(id){
        this.showLoading()

        UsersService.update(id).then(() => {
          this.showSuccess()
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      dateTimeV2(value) {
        return moment(value).format("YYYY-MM-DD");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search,   
          filter_by: this.filter_by,
          kyc_status: this.kyc_status,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)       
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        UsersService.getAll(params).then(e => {
          const data = e.data
          this.records = data.listofregistrationdata
          this.totalRecords = data.count
        })

        // Update query params di route agar bisa diingat
        this.$router.replace({
          path: '/external-users',     // sesuaikan path Anda
          query: {
            search: this.search,
            filter_by: this.filter_by,
            limitPerPage: this.limitPerPage,
            currentPage: this.currentPage,
            date_start: this.dateTimeV2(this.dates.range.startDate),
            date_end: this.dateTimeV2(this.dates.range.endDate),
            sortByName: this.sortBy.name,
            sortByType: this.sortBy.sortType
          }
        })
      }
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      downloadExcel:JsonExcel,
      BaseInput,
      DateRangePicker,

    },
    mounted() {
      const { query } = this.$route

      // jika ada query search, restore
      if(query.search){
        this.search = query.search
      }
      if(query.filter_by){
        this.filter_by = query.filter_by
      }
      if(query.limitPerPage){
        this.limitPerPage = parseInt(query.limitPerPage, 10)
      }
      if(query.currentPage){
        this.currentPage = parseInt(query.currentPage, 10)
      }
      if(query.sortByName && query.sortByType){
        this.sortBy.name = query.sortByName
        this.sortBy.sortType = query.sortByType
      }
      // date_start & date_end
      // if(query.date_start && query.date_end){
      //   // parse string ke Date
      //   const start = moment(query.date_start, "YYYY-MM-DD").toDate()
      //   const end = moment(query.date_end, "YYYY-MM-DD").toDate()
      //   this.dates.range.startDate = start
      //   this.dates.range.endDate = end
      // }

      this.getAllAPI()
    },
  };
  </script>
  